__turbopack_context__.v({
  "heading": "TripOverviewCommunityHighlights-module__Ii4-OW__heading",
  "section": "TripOverviewCommunityHighlights-module__Ii4-OW__section",
  "trustpilotLink": "TripOverviewCommunityHighlights-module__Ii4-OW__trustpilotLink",
  "widgetSlot": "TripOverviewCommunityHighlights-module__Ii4-OW__widgetSlot",
});
